<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    :bottom="snackbar.bottom"
    :left="snackbar.left"
  >
    {{ snackbar.text }}
    <v-btn
      dark
      flat
      @click="snackbar.show = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>

export default {
  components: {
  },

  data () {
    return {
      snackbar: {
        show: false,
        bottom: true,
        left: true,
        color: 'success',
        mode: '',
        timeout: 10000,
        text: 'snackbar text'
      }      
    }
  },
  methods: {
    showAnyToast () {
      if (this.$store.state.pendingMessage) {
        console.log("GOT A PENDING MESSAGE!")
        this.snackbar.text = this.$store.state.pendingMessage.text ;
        this.snackbar.color = this.$store.state.pendingMessage.color ;
        this.snackbar.show = true ;
        this.$store.dispatch('clearPendingMessage') ;
      }
    }
  },
  async mounted () {
    this.showAnyToast() ;

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Toast.vue